/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Add_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Add new event group" |
*
* @param {Editor_Add_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_add_event_group = /** @type {((inputs?: Editor_Add_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Add_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un nouveau groupe d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Ereignisgruppe hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi nuovo gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить новую группу событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar nuevo grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加新事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントグループを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया इवेंट समूह जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar novo grupo de eventos")
	return /** @type {LocalizedString} */ ("Add new event group")
});